export const capitalizeString = (input: string): string =>
  input.length > 1 ? input.charAt(0).toUpperCase() + input.slice(1) : input.toUpperCase();
